module.exports = __webpack_public_path__ + "img/two.c07b00c4.png";